<script setup lang="ts">
import { computed, ref } from 'vue'
import { Icon } from '@iconify/vue'
import './account_card.scss'
import { getFirstCharacterName } from '@/utils/helper.ts'
import BrokerDetail from '@/modules/broker/views/BrokerDetail.vue'
import AccountDetail from '@/modules/account/views/AccountDetail.vue'

interface Props {
  data: object | string | number,
  class?: string,
  cellConfig?: Object,
  accountType?: string,
}

const props = defineProps<Props>()

const showBroker = ref<boolean>(false)
const showAccount = ref<boolean>(false)

const handleShowDetail = () => {
  if(props.accountType === 'customer') {
    showBroker.value = false
    showAccount.value = true
  }
  else if(props.accountType === 'broker') {
    showBroker.value = true
    showAccount.value = false
  }
}

</script>

<template>
  <div class="flex flex-1 items-start gap-[7px] account-card-small rounded-[8px]" :class="props.class">
    <div class="thumb">
      <Avatar size="xlarge" :image="props.data?.avatar" v-if="props.data?.avatar"/>
      <Avatar size="xlarge" :label="getFirstCharacterName(props.data?.full_name)" class="text-avatar" v-else/>
    </div>
    <div class="flex flex-1 flex-col" @click="handleShowDetail">
      <div class="text-[12px] font-bold full-name">{{ props.data?.full_name }}</div>
      <div class="flex flex-1 flex-col w-full">
        <div class="flex gap-[3px] items-center">
          <Icon icon="mage:qr-code-fill" color="#c9c9c9"/> #{{props.data?.code}}
        </div>
        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-1 gap-[3px] items-center">
            <Icon icon="zondicons:phone" color="#c9c9c9"/> {{props.data?.phone_number}}
          </div>
          <div class="flex flex-row flex-1 gap-[3px] items-center">
            <Icon icon="ic:baseline-email" color="#c9c9c9"/>
            <span class="flex-1">{{props.data?.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-btn" @click="handleShowDetail"><Icon icon="bi:info-circle-fill" /> chi tiết</div>
  </div>
  <Drawer v-model:visible="showBroker" header="Thông tin môi giới" position="right">
    <div class="drawer-80vw">
        <BrokerDetail :id="props.data?.broker_profile?.id"/>
    </div>
  </Drawer>
  <Drawer v-model:visible="showAccount" header="Thông tin khách hàng" position="right">
    <div class="drawer-80vw">
      <AccountDetail :id="props.data?.id"/>
    </div>
  </Drawer>
</template>

<style scoped>

</style>
